module.exports = __webpack_public_path__ + "static/media/76deec39.jpg";